export const environment = {
  production: true,
  training: false,
  api_server: 'https://marketmanager.marktgilde.de:8443/',
  api_server_training: '###API_URL_STAGING###',
  api_server_version: 'v5',
  merchant_webapp: 'https://beschicker.treffpunkt-wochenmarkt.de/',
  pimcore: 'https://backend.treffpunkt-wochenmarkt.de/',
  merchant_webapp_user: 'marktgilde',
  merchant_webapp_password: 'b1I3b8d1t4K2h1E3',
};



// WEBPACK FOOTER //
// ./src/environments/environment.ts